import * as React from 'react';
const SvgRadioOn = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none" }, props),
    React.createElement("path", { fill: "#E1E1E1", fillOpacity: 0.8, d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11Z" }),
    React.createElement("path", { fill: "#FA667C", d: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" })));
export default SvgRadioOn;
